import * as Yup from 'yup'

import { itemValidationSchema } from '../../../constants/validationSchema'

export const validationSchema = Yup.object({ option: itemValidationSchema })
